import React, {Component} from 'react';
import css from './Attachments.module.scss';
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import fileDownload from "js-file-download";
import {connect} from "react-redux";
import Modal from 'react-modal';
import moment from 'moment';
import { fetchS3Photos, repUpload } from '../../utils/awsHelper';
import ProgressBar from '../../components/ProgressBar/ProgressBar';


/**
 * @class
 */
const Attachments = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.match.params.id;
    opportunityName = this.props.match.params.name;
    username = this.props.user.name;

    postRequestFindAttachments = {
        "limit": 1000,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Body",
            "BodyLength",
            "ContentType"
        ],
        "where": {
            "IsDeleted": false,
            "ParentId": this.opportunityId
        }
    };

    postRequestOpportunity = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Deal_Documents__c",
            "Deal_Documents__r.Text_Out_Hold_Reason__c",
            "Deal_Documents__r.Deal_Docs_Verified__c",
            "Deal_Documents__r.Approval_Outcome__c"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    // ---------- state: ----------
    state = {
        attachedFiles: [],
        oldAttachedFiles: [],
        filesToUpload: [],
        progressColor: "#00695c",
        progressAmount: "0",
        disableUpload: false,
        opportunity: {},
        uploading: false,
        currentDoc: '',
        errorUpload:false,
        failedDoc:'',
        errorDoc:'',

        // text out hold modal variables
        isTextOutHold: false,
        holdResolvedModalOpen: false,
        holdResolvedButtonsDisabled: false,
        holdResolvedSuccessful: false
    };

    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);
        await this.getDocs();

        axios.post('/sf/attachment/find',
            this.postRequestFindAttachments,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    oldAttachedFiles: res.data.records
                });
            })

        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpportunity,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const opp = res.data.records[0];
                this.setState({opportunity: opp});

                if(opp && opp.Deal_Documents__c && opp.Deal_Documents__r.Text_Out_Hold_Reason__c && opp.Deal_Documents__r.Approval_Outcome__c != 'Approved' && !opp.Deal_Documents__r.Deal_Docs_Verified__c){
                    this.setState({isTextOutHold: true});
                }
            })
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getDocs = async() => {
        fetchS3Photos({
                recordId: this.opportunityId,
                type: 'portal',
                existingState: this.state,
                source: this.source,
                process: 'getRepUploads'
            })
            .then(returnedFiles => {
                if(returnedFiles.length !== 0){
                    let tempArray = [];
                    Object.keys(returnedFiles).map(name => {
                        let parts = returnedFiles[name].split('/');
                        let docName = parts[parts.length - 1];
                        tempArray.push({Name: docName, Id: returnedFiles[name]});
                    })
                    this.setState({attachedFiles: tempArray})
                }
            })
            .catch(err => {
                console.error('AWS S3 fetch error:', err);
                this.setState({ errorMessage: err.message });
            });
    };

    sanitizeFileName = (input) => {
        if (!input) return "file";

        const dot = input.lastIndexOf(".");
        const baseRaw = dot > 0 ? input.slice(0, dot) : input;
        const ext = dot > 0 ? input.slice(dot).toLowerCase() : "";

        let base = baseRaw.normalize("NFKD").replace(/\p{Diacritic}/gu, "");
        base = base.replace(/\s+/g, "-");
        base = base.replace(/[^a-zA-Z0-9._-]/g, "");
        base = base.replace(/[._-]{2,}/g, "-");
        base = base.replace(/^[-._]+|[-._]+$/g, "");
        base = base.toLowerCase();
        if (!base) base = "file";
        const MAX_BASE_LEN = 200;
        if (base.length > MAX_BASE_LEN) base = base.slice(0, MAX_BASE_LEN);

        return base + ext;
    };

    fileInputOnChange = async (files) => {
        if (!files || files.length === 0) return;

        this.setState({uploading: true})
        let i = 0;

        for (const file of files) {
            i += 1;
            let prog = i / files.length;
            const fileName = this.sanitizeFileName(file.name);
            this.setState({currentDoc:fileName});
            try {
                await repUpload({
                    file,
                    fileName,
                    username: this.username,
                    opportunityId: this.opportunityId,
                    source: this.source,
                });
                this.setState({progressAmount: (prog.toFixed(2) * 100).toString()});
            } catch (err) {
                console.log('Upload failed for', fileName, err);
                this.setState({errorUpload:true, failedDoc: fileName, errorDoc: err});
            }
        }

        setTimeout(() => {
            this.setState({uploading: false, currentDoc: '', progressAmount: '0'});
            this.getDocs();
        }, 3000);
    };

    /**
     * @method
     * @methodOf Attachments
     *
     * Handler for when user clicks the download button -- downloads the file to user's machine.
     *
     * @param id {string}: File id -- this is used in the API endpoint.
     * @param attachmentName {string}: Name of the file/attachment -- this is used in the API endpoint.
     */
    downloadOnClick = (id, attachmentName) => {
        // we use js-file-download package <https://github.com/kennethjiang/js-file-download#binary-downloads> to help download files via axios:
        axios.get(
            `/sf/attachment/download/${id}/${attachmentName}`,
            {
                responseType: 'blob',
                cancelToken: this.source.token
            })
            .then((res) => {
                fileDownload(res.data, attachmentName);
            })
            .catch(err => console.log('Error while trying to download file:\n', err));
    };

    downloadOnClickS3 = async (name, key) => {
        const payload = {
            method: 'GET',
            process: 'getUrl',
            bucket: 'v3-portal-file-storage',
            key: key.split('https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/')[1],
            expiresSec: 60,
            RecordId: this.opportunityId
        };

        await axios.post(
            '/postAWS',
            payload,
            {
                cancelToken: this.source.token
            })
            .then(async (res) => {
                const url = res.data.key;
            
                const uploadRes = await fetch(url);
                if (!uploadRes.ok) throw new Error(`S3 GET failed: ${res.status}`);
                const blob = await uploadRes.blob();
                fileDownload(blob, name);
            })
            .catch(err => {
                console.log(err)
            });
    };

    /**
     * @method
     * @methodOf Attachments
     *
     * Handler for when user clicks the 'back' button -- goes to previous page (using router history).
     */
    btnGoBackOnClick = () => {
        this.props.history.goBack();
    };

    confirmHoldResolved = () => {
        this.setState({holdResolvedButtonsDisabled: true})

        const payload = {
            Id: this.state.opportunity.Deal_Documents__c,
            Text_out_hold_Recheck__c: moment().format(this.SF_DATE_TIME_FORMAT) // now
        };

        axios.put(
            '/sf/DealDocument/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({holdResolvedButtonsDisabled: false, holdResolvedSuccessful: true});
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update deal docs: \n', err);
                this.setState({holdResolvedButtonsDisabled: false});
            });
    }

    closeHoldResolved = () => {
        this.setState({
            holdResolvedModalOpen: false,
            holdResolvedSuccessful: false,
            holdResolvedButtonsDisabled: false
        })
    }

    render() {
        return (
            <div className={css.Attachments}>
                <h4 className="m-0">Name</h4>
                <h1>{this.opportunityName}</h1>

                <div className={`${css.Attachments__Main} mt-5`}>

                    {/* ---------- File Upload: ---------- */}
                    <div>
                        <div className="d-flex mb-4">
                            <button className={this.state.isTextOutHold === true ? "btn btn-primary" : "d-none"} type="button" onClick={() => this.setState({holdResolvedModalOpen: true})}>
                                Text Out Hold Recheck
                            </button>
                            <button className="btn btn-primary ml-auto" type="button" onClick={() => this.btnGoBackOnClick()}>
                                Done
                            </button>
                        </div>

                        <h2>Select Files to Attach:</h2>
                        <div className={css.Attachments__FileInput}>
                            <input
                                ref={this.refFileInput}
                                name="inputFile"
                                type="file"
                                multiple
                                onChange={(event) => this.fileInputOnChange(event.target.files)}
                            />
                            <button className="btn btn-primary" type="button">Select File(s)</button>
                        </div>
                        {this.state.uploading ?
                            <div className='container mt-5'>
                                <div className="row py-3">
                                    <div className="col-6 col-sm-4">Uploading Doc</div>
                                    <div className="col-6 col-sm-8">Overall Progress</div>
                                </div>
                                <div className="row py-3">
                                    <div className="col-6 col-sm-4 font-weight-bold">
                                        { this.state.currentDoc }
                                    </div>
                                    <div className="col-6 col-sm-8">
                                        <span><ProgressBar bgcolor="#00695c" completed={this.state.progressAmount} /></span>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }
                        {this.state.errorUpload ?
                            <div className='container mt-5'>
                                <div className="row py-3">
                                    <div className="col-6 col-sm-4">Upload Failed</div>
                                    <div className="col-6 col-sm-8">Error Message</div>
                                </div>
                                <div className="row py-3">
                                    <div className="col-6 col-sm-4 font-weight-bold">
                                        { this.state.failedDoc }
                                    </div>
                                    <div className="col-6 col-sm-4 font-weight-bold">
                                        { this.state.errorDoc }
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>

                    {/* ---------- Attachment list: ---------- */}
                    <div className="mt-5">
                        <h2>Attachments</h2>

                        <h4 className={Object.entries(this.state.attachedFiles).length ? 'd-none' : 'my-4 text-center'}>
                            There are no attachments
                        </h4>

                        <div className={Object.entries(this.state.attachedFiles).length ? `${css.Attachments__List} container` : 'd-none'}>
                            <div className="row py-3">
                                <div className="col-6 col-sm-4">Name</div>
                                <div className="col-6 col-sm-8">Link</div>
                            </div>
                            {this.state.attachedFiles &&
                                this.state.attachedFiles.map((attachment) => (
                                <div key={attachment.Id} className="row py-3">
                                    <div className="col-6 col-sm-4 font-weight-bold">{attachment.Name}</div>
                                    <div className="col-6 col-sm-8">
                                        <button className={`btn btn-light ${css.DownloadButton}`}
                                                type="button"
                                                onClick={() => this.downloadOnClickS3(attachment.Name, attachment.Id)}
                                        >
                                            <FontAwesomeIcon icon={faArrowAltCircleDown} />
                                            <span className="ml-2">Download</span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* ---------- Legacy Attachment list: ---------- */}
                    <div className="mt-5">
                        <h2>Legacy Attachments</h2>

                        <h4 className={this.state.oldAttachedFiles.length ? 'd-none' : 'my-4 text-center'}>
                            There are no legacy attachments
                        </h4>

                        <div className={this.state.oldAttachedFiles.length ? `${css.Attachments__List} container` : 'd-none'}>
                            <div className="row py-3">
                                <div className="col-6 col-sm-4">Name</div>
                                <div className="col-6 col-sm-8">Link</div>
                            </div>

                            {
                                this.state.oldAttachedFiles.map(attachment => {
                                    return (
                                        <div key={attachment.Id} className="row py-3">
                                            <div className="col-6 col-sm-4 font-weight-bold">{attachment.Name}</div>
                                            <div className="col-6 col-sm-8">
                                                <button className={`btn btn-light ${css.DownloadButton}`}
                                                        type="button"
                                                        onClick={() => this.downloadOnClick(attachment.Id, attachment.Name)}
                                                >
                                                    <FontAwesomeIcon icon={faArrowAltCircleDown} />
                                                    <span className="ml-2">Download</span>
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                {/* ---------- HoldResolvedModal: ---------- */}
                <Modal
                    isOpen={this.state.holdResolvedModalOpen}
                    onRequestClose={() => this.closeHoldResolved()}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Text Out Hold Recheck</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.closeHoldResolved()} />
                        </span>
                    </div>

                    <div className={this.state.holdResolvedSuccessful !== true ? "" : "d-none"}>
                        <div className="mt-3 text-white">
                            <p>Please confirm that you want the office to re-check the uploaded documents and confirm the sold text out.</p>
                        </div>

                        <div className="mt-3 text-right text-white">
                            <button className="btn btn-primary" type="button" disabled={this.state.holdResolvedButtonsDisabled} onClick={() => this.confirmHoldResolved()}>Confirm</button>
                            &nbsp;
                            <button className="btn btn-primary" type="button" onClick={() => this.closeHoldResolved()}>Cancel</button>
                        </div>
                    </div>

                    <div className={this.state.holdResolvedSuccessful === true ? "" : "d-none"}>
                        <div className="mt-3 text-white">
                            <p>Office has been notified to re-check the uploaded documents and confirm the sold text out.</p>
                        </div>
                        <div className="mt-3 text-right text-white">
                            <button className="btn btn-primary" type="button" onClick={() => this.closeHoldResolved()}>Close</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(Attachments);
